import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as DOCUMENT_NAME from '../../constants/documentNames';

const firebaseRef = firebase.database();

export default function getCoolingPeriodTime(leadId, callback) {
	firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId)
		.once('value', (snapshot) => {
			var documentInformation = snapshot.val()?.documentInformation;

			var signatureRequestsObj = documentInformation?.signatureRequests;

			console.log(
				'getCoolingPeriodTime signatureRequestsObj 16',
				signatureRequestsObj
			);

			//search for aps key

			var signatureRequestsObjKeys =
				signatureRequestsObj && Object.keys(signatureRequestsObj);

			console.log(
				'getCoolingPeriodTime signatureRequestsObjKeys 26',
				signatureRequestsObjKeys
			);

			var apsKeyFound;

			signatureRequestsObjKeys &&
				signatureRequestsObjKeys?.forEach((key) => {
					var subject = signatureRequestsObj[key]['subject'];

					console.log('getCoolingPeriodTime subject 36', subject);
					console.log(
						'getCoolingPeriodTime subject DOCUMENT_NAME.aps',
						DOCUMENT_NAME.aps
					);

					if (subject === DOCUMENT_NAME.aps) {
						apsKeyFound = key;
					}
				});

			console.log('getCoolingPeriodTime keyFound 41', apsKeyFound);

			var apsDocKey =
				signatureRequestsObj && signatureRequestsObj[apsKeyFound];

			console.log('getCoolingPeriodTime apsDocKey', apsDocKey);

			var signatureUpdatesObj =
				apsDocKey && apsDocKey['signatureUpdates'];

			console.log(
				'getCoolingPeriodTime signatureUpdatesObj 58',
				signatureUpdatesObj
			);

			//get the latest update
			var signatureUpdatesObjKeys =
				signatureUpdatesObj && Object?.keys(signatureUpdatesObj);

			console.log(
				'getCoolingPeriodTime signatureUpdatesObjKeys',
				signatureUpdatesObjKeys
			);

			var latestUpdateObj =
				signatureUpdatesObj &&
				signatureUpdatesObj[
					signatureUpdatesObjKeys[signatureUpdatesObjKeys?.length - 1]
				];

			console.log(
				'getCoolingPeriodTime latestUpdateObj',
				latestUpdateObj
			);

			var signature_request =
				latestUpdateObj && latestUpdateObj['signature_request'];

			var signatureObjects =
				signature_request && signature_request['signatures'];

			console.log(
				'getCoolingPeriodTime signatureObjects',
				signatureObjects
			);

			var signatureArr = [];

			var signatureObjectsKeys =
				signatureObjects && Object?.keys(signatureObjects);

			signatureObjectsKeys?.forEach((key) => {
				var signature = {
					latestUpdateObj: latestUpdateObj,
					signerRole: signatureObjects[key]['signer_role'],
					status: signatureObjects[key]['status_code'],
					signedAt: signatureObjects[key]['signed_at'],
				};

				signatureArr.push(signature);
			});

			console.log('getCoolingPeriodTime signatureArr', signatureArr);

			// console.log('purchasersAmount', purchasersAmount);
			signatureArr.find((item) => {
				if (item?.signerRole === 'Builder') {
					console.log('getCoolingPeriodTime BuilderBuilderBuilder');
					if (item?.status === 'signed') {
						console.log(
							'getCoolingPeriodTime this is singed',
							item.latestUpdateObj
						);
						callback(item?.signedAt ? item?.signedAt * 1000 : '');
					}
				}
			});
		});
}
